import React, { Fragment, useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import {
  useRefresh,
  useShowController,
  ShowView,
  TabbedShowLayout,
  SimpleShowLayout,
  Tab,
  // NumberField,
  // ChipField,
  TopToolbar,
  // ReferenceField,
  // ShowGuesser,
  useDataProvider,
} from 'react-admin';
import { FacilityHistoryModal } from './facility-history';
import { NewEvent, Attachments } from '../../components/common/modals';
import { AddAttachmentModal } from '../../components/common/modals/modalForms';
import { GeneralInfo } from './general-info';
import { FacilityContacts } from './facility-contacts';
import { CommunicationGroups } from './communication-groups';
import { constants, formatDateString } from '../../utils';
import { useStyles } from './facility.styles';
import {
  FacilityIcon,
  EditIcon,
  AccessTimeIcon,
  AttachmentIcon,
  CustomButton,
  DeactivateFacilityIcon,
} from '../../design';
import { TrackUser } from '../../components/wrappers';
const { eventTypes } = constants;

const ShowActions = ({ basePath, data = {}, title, resource, permissions }) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  // State for modals and data
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyOpen, setHistoryModal] = useState(false);
  const [editOpen, setEditModal] = useState(false);
  const [attchOpen, setAttchModal] = useState(false);
  const [transitionFacilityOpen, setTransitionFacility] = useState(false);
  const [deactivateFacilityOpen, setDeactivateFacility] = useState(false);

  const { document_ids, inactive, facility_log_id } = data || {};
  const hasAttachments =
    !!data && Array.isArray(document_ids) && !!document_ids.length;
  const documentCount = document_ids?.length;
  const isAdmin =
    Array.isArray(permissions) && permissions.indexOf('admin') > -1;
  const isSupervisor = permissions?.indexOf('supervisor') > -1;
  const isViewAdmin = permissions?.indexOf('view_admin') > -1;
  const isAdminAssistant = permissions?.indexOf('admin_assistant') > -1;
  return (
    <Fragment>
      <TopToolbar className={classes.listActionWrapper}>
        <div className={classes.title}>
          Facility details
          <div
            className={classes.subtitle}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: 10,
            }}
          >
            Created by
            {'      '} {data?.facilityCreatedBy?.name} {'      '}| Last modified
            on{' '}
            <div
              style={{
                width: 3,
              }}
            />
            <TrackUser timestamp={data?.updated_at} />
          </div>
          <div
            className={classes.subtitle}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: 10,
            }}
          >
            {/* show both dates here, called transition date, if no transition, hide it */}
            {data?.group_start_date && (
              <span>
                Transition Date:
                {'      '} {formatDateString(data?.group_start_date)}{' '}
              </span>
            )}
            <span>
              Start date:
              {'      '} {formatDateString(data?.start_date)}{' '}
            </span>
            {data?.contract_end_date && (
              <span>
                Contract end date:
                {'      '} {data?.contract_end_date}{' '}
              </span>
            )}
          </div>
          {data?.inactive && (
            <div
              className={classes.subtitle}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: 10,
              }}
            >
              <span className={classes.inactiveItem}>
                Inactive as of:
                {'      '}
                {data?.last_active_date}
              </span>
            </div>
          )}
        </div>

        <div
          className={clsx(classes.addContainer, {
            [classes.adminAddContainer]:
              (isAdmin || isAdminAssistant) && !facility_log_id,
          })}
        >
          {(isAdmin || isAdminAssistant) && !facility_log_id && (
            <CustomButton
              Icon={inactive ? undefined : DeactivateFacilityIcon}
              backgroundColor='#1061A0'
              color='#FFFFFF'
              label={inactive ? 'Reactivate facility' : 'Deactivate facility'}
              type='button'
              variant='text'
              size='small'
              onClick={() => setDeactivateFacility(true)}
            />
          )}
          {isAdmin && !facility_log_id && (
            <CustomButton
              Icon={FacilityIcon}
              color='#1061A0'
              backgroundColor='#EFF4FB'
              label='Transition facility'
              type='button'
              variant='text'
              size='small'
              onClick={() => setTransitionFacility(true)}
              style={{
                marginLeft: 3,
              }}
            />
          )}
          {(isAdmin || isSupervisor || isAdminAssistant) && !facility_log_id && (
            <Fragment>
              <CustomButton
                Icon={EditIcon}
                color='#1061A0'
                backgroundColor='#EFF4FB'
                label='Edit'
                type='button'
                variant='text'
                size='small'
                onClick={() => setEditModal(true)}
              />
              {(isAdmin || isAdminAssistant) && !facility_log_id && (
                <CustomButton
                  Icon={AccessTimeIcon}
                  color='#1061A0'
                  backgroundColor='#EFF4FB'
                  label='History'
                  type='button'
                  variant='text'
                  size='small'
                  onClick={() => {
                    // Fetch facility history data using dataProvider
                    setHistoryLoading(true);
                    setHistoryModal(true); // Open modal immediately to show loading spinner
                    dataProvider
                      .getList(`facility-history/${data.id}`, {
                        pagination: { page: 1, perPage: 100 },
                        sort: { field: 'created_at', order: 'desc' },
                      })
                      .then(result => {
                        setHistoryData(result.data || []);
                        setHistoryLoading(false);
                      })
                      .catch(error => {
                        console.error(
                          'Error fetching facility history:',
                          error,
                        );
                        setHistoryLoading(false);
                      });
                  }}
                />
              )}
            </Fragment>
          )}
          {!facility_log_id && (
            <CustomButton
              Icon={AttachmentIcon}
              label={hasAttachments ? 'View attachment' : 'Add attachment'}
              color='#1061A0'
              backgroundColor='#EFF4FB'
              type='button'
              variant='text'
              size='small'
              onClick={() => setAttchModal(true)}
              badgeContent={documentCount}
              notRed
              style={{
                marginLeft: 3,
              }}
            />
          )}
        </div>
      </TopToolbar>
      {editOpen && (
        <NewEvent
          open={editOpen}
          handleClose={() => setEditModal(false)}
          form='facility'
          refresh={refresh}
          record={data}
          isEdit
        />
      )}
      {deactivateFacilityOpen && (
        <NewEvent
          open={deactivateFacilityOpen}
          handleClose={() => setDeactivateFacility(false)}
          form={inactive ? 'reactivateFacilityForm' : 'deactivateFacilityForm'}
          refresh={refresh}
          record={data}
          isEdit={inactive}
        />
      )}
      {transitionFacilityOpen && (
        <NewEvent
          open={transitionFacilityOpen}
          handleClose={() => setTransitionFacility(false)}
          form='transitionFacilityForm'
          refresh={refresh}
          record={data}
          maxWidth='md'
        />
      )}
      {attchOpen && (
        <Fragment>
          {hasAttachments ? (
            <Attachments
              open={attchOpen}
              handleClose={() => setAttchModal(false)}
              document_ids={data?.document_ids}
              title='Facility'
              eventId={data.id}
              eventName={eventTypes.FACILITY_NAME}
              refresh={refresh}
              isViewAdmin={isViewAdmin}
            />
          ) : (
            <AddAttachmentModal
              open={attchOpen}
              handleClose={() => setAttchModal(false)}
              title='Facility'
              eventId={data.id}
              eventName={eventTypes.FACILITY_NAME}
              refresh={refresh}
              isViewAdmin={isViewAdmin}
            />
          )}
        </Fragment>
      )}

      {/* Facility History Modal - Moved outside attachment conditional */}
      <FacilityHistoryModal
        open={historyOpen}
        onClose={() => {
          setHistoryModal(false);
          // Reset history data when closing the modal
          setHistoryData([]);
        }}
        historyData={historyData}
        isLoading={historyLoading}
      />
    </Fragment>
  );
};

const FacilityPageView = props => {
  const basePath = '/facility-details';
  const showProps = useShowController({
    ...props,
    resource: 'facilities',
    basePath,
  });
  const classes = useStyles();
  return showProps.record?.facility_logs ? (
    <TabbedShowLayout>
      <Tab
        classes={{ root: classes.tab, selected: classes.selectedTab }}
        label={showProps.record.name}
      >
        <FacilityDetailsView showProps={showProps} {...props} />
      </Tab>
      {showProps.record?.facility_logs.map(facility_log => (
        <Tab
          classes={{ root: classes.tab, selected: classes.selectedTab }}
          label={facility_log.name}
          path={`prev_${facility_log.id}`}
        >
          <FacilityDetailsView
            showProps={{
              ...showProps,
              record: { facility_log_id: facility_log.id, ...facility_log },
            }}
            {...props}
          />
        </Tab>
      ))}
    </TabbedShowLayout>
  ) : (
    <FacilityDetailsView showProps={showProps} {...props} />
  );
};

const FacilityDetailsView = ({ showProps, ...props }) => {
  const classes = useStyles();
  const { permissions = '' } = props;
  const userPermissions = permissions.split(',');

  // Clean ALL basePath references
  const { basePath: showBasePath, ...cleanShowProps } = showProps;
  const { basePath: propsBasePath, ...cleanProps } = props;

  return (
    <Fragment>
      {/* Use ShowView for the first section but with explicit props to avoid basePath spreading */}
      <ShowView
        resource={cleanShowProps.resource}
        record={cleanShowProps.record}
        loading={cleanShowProps.loading}
        loaded={cleanShowProps.loaded}
        defaultTitle={cleanShowProps.defaultTitle}
        actions={<ShowActions permissions={userPermissions} />}
      >
        <GeneralInfo permissions={userPermissions} />
      </ShowView>

      {/* Replace ShowView for second section with basic structure */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ padding: 16, backgroundColor: 'white', borderRadius: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <div
            style={{
              paddingBottom: 20,
              paddingTop: 20,
            }}
          >
            <SimpleShowLayout resource={cleanShowProps.resource} record={cleanShowProps.record}>
              <div className={classes.title}>Facility contacts</div>
              <FacilityContacts
                {...cleanProps}
                permissions={userPermissions}
                isAdmin={Array.isArray(userPermissions) && userPermissions.indexOf('admin') > -1}
                isViewAdmin={userPermissions?.indexOf('view_admin') > -1}
                isAdminAssistant={userPermissions?.indexOf('admin_assistant') > -1}
              />
            </SimpleShowLayout>
          </div>
        </div>
      </div>

      {/* Replace ShowView for third section */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ padding: 16, backgroundColor: 'white', borderRadius: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <div
            style={{
              paddingBottom: 20,
              paddingTop: 20,
            }}
          >
            <SimpleShowLayout resource={cleanShowProps.resource} record={cleanShowProps.record}>
              <div className={classes.title}>Communication groups</div>
              <CommunicationGroups
                {...cleanProps}
                permissions={userPermissions}
                isAdmin={Array.isArray(userPermissions) && userPermissions.indexOf('admin') > -1}
                isViewAdmin={userPermissions?.indexOf('view_admin') > -1}
                isAdminAssistant={userPermissions?.indexOf('admin_assistant') > -1}
              />
            </SimpleShowLayout>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => {
  const { facility: { id } = {} } = state;
  return {
    id,
  };
};

// Need this because we are using 'useShowController' which is a
// react hook and we can't check if id when using hooks.
const Wrapper = props => {
  return props.id ? <FacilityPageView {...props} /> : null;
};

export const FacilityPage = connect(mapStateToProps, {})(Wrapper);

export const facilityResource = {
  name: 'facilities',
  list: FacilityPage,
  // show: ResidentShow,
  icon: FacilityIcon,
  options: { label: 'Facility Details' },
};
